import React from 'react';

const PaymentContext = React.createContext({
  /** @type {SelectedTreatments} a filtered selected treatments */
  treatmentsToRead: [],
  /** @type {SelectedTreatments} */
  selectedTreatments: [],
  /** @type {() => Promise<void>} */
  handlePaymentButton: () => Promise.resolve(),
  /** @type {boolean} */
  isCheckoutLoaded: false,
  /** @type {boolean} */
  termsRead: false,
  /** @type {string | undefined} */
  description: '',
  /** @type {CheckoutDataType} */
  checkoutData: {
    appliedCredit: 0,
    discount: 0,
    discountCode: '',
    finalAmount: '0.00',
    groupedProducts: [],
    gst: 0,
    products: [],
    productsPrice: 0,
    productsPriceGST: 0,
    shippingCharge: 0,
    shippingChargeGST: 0,
  },
  /** @type {React.Dispatch<React.SetStateAction<CheckoutDataType>>} */
  setCheckoutData: () => {},
  /** @type {FormCategory | ''} */
  formName: '',
  /** @type {boolean} */
  scriptMode: false,
  /** @type {() => void} */
  handleTermsRead: () => {},
  /** @type {string} */
  shippingAlert: '',
  /** @type {string} */
  promoCode: '',
  /** @type {React.Dispatch<React.SetStateAction<string>>} */
  setPromoCode: () => {},
  /** @type {boolean} */
  pharmacyConsentRead: false,
  /** @type {boolean} */
  isPickup: false,
  /** @type {boolean} */
  isPharmacyPending: false,
  /** @type {boolean} */
  showPaymentMethods: false,
  /** @type {React.Dispatch<React.SetStateAction<boolean>>} */
  setShowPaymentMethods: () => {},
  /** @type {string} */
  paymentProcessor: '',
  /** @type {CatalogueMap} */
  treatmentTranslator: {},
  /** @type {string} */
  reference: '',
  /** @type {boolean} */
  isPromoLoading: false,
  /** @type {React.Dispatch<React.SetStateAction<boolean>>} */
  setIsPromoLoading: () => {},
  /** @type {string | null} */
  selectedPharmacy: '',
  /** @type {ExternalPharmacyInfo} */
  preferredPharmacy: { address: '', phone: '', name: '' },
  /** @type {CatalogueMap} */
  catalogue: {}, // gets loaded in purchase by 'Prescriptions' component as treatmentTranslator
});

export default PaymentContext;
